import Confirm from './Confirm'

import Edit from './Edit'
import { ReactComponent as ArrowIcon } from '../../img/arrow-feedback.svg';
import Modal from "./Modal";
import { componentOpenDelete, componentOpenEdit } from './utils';
import {useState} from "react";

const OrganizationItem = (props) => {
	const {idO, onDelete, clickHandler,children} = props;
	const [name] = useState(props.name)
    const [openChildren,setOpenChildren] = useState(false)
    function Next(){
        localStorage.setItem('idO', idO);
        localStorage.setItem('nameO', props.name);
        clickHandler(idO)
    }

    function deleteOrganization() {
        onDelete(idO)
    }

    function func(e) {
        e.preventDefault()
	    e.stopPropagation()

        if(e.target.className.includes('adaptive') ){
            clickHandler(idO)
        }
    }
    const editOrganization=()=>{
        props.setOrganization()
    }
    const childrenElement = children?.map(item=> {
        return < OrganizationItem
        key = {item.idOrganization}
        idO = {item.idOrganization}
        {...
            item
        }
        onDelete = {onDelete}
        clickHandler = {clickHandler}
        setOrganization = {Next}
        />}

    )

    function openChildrenHandler(e) {
	    e.stopPropagation()
        setOpenChildren(prev=>!prev);
    }

    return (
        <div>
            <div className="organization-wrapper"
                 onClick={(e) => {
                func(e)}}
            >
                <p className="adaptive" onClick={()=>Next()}>{name}</p>
                <div className='organization_img'>
                    <Modal additional={{name: name, type:'organization', idO:idO,editOrganization:editOrganization}} componentOpen={componentOpenEdit} component={Edit}/>
                    <Modal additional={{funcYes: deleteOrganization, text: "Вы уверенны что хотите удалить?"}} componentOpen={componentOpenDelete} component={Confirm}/>
                    {children && <span onClick={(e)=>openChildrenHandler(e)} className={'profile_edit-open'}>
                        {openChildren ?<ArrowIcon className={'upArrow'} fill={'#9DB4FF'}/>:<ArrowIcon fill={'#9DB4FF'}/>}
                    </span>}
                </div>
            </div>
            {openChildren && <div style={{marginLeft: '15px'}}>
                {childrenElement}
            </div>}
        </div>
	)
}

export default OrganizationItem;